import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import React, { useEffect, useState } from 'react';
import {useForm} from "react-hook-form";
import UploadFile from '../../shared/uploadFile';
import { cadastrar } from '../../../services/documento/DocumentoService';
import { useSnackbar } from 'notistack';


const CadastrarDocumento = (props) => {
  const { open, onClose, tipos, afterSubmit } = props;
  const { enqueueSnackbar } = useSnackbar();
  const { register, handleSubmit, errors, setValue, clearError } = useForm();

  const initialState = {
    nome: '',
    idTipo: '',
  }

  const [file, setFile] = useState(null);
  const [form, setForm] = useState(initialState);
  const handleChange = (event) => {
    const { name, value } = event.target
    setValue(name, value);
    clearError(name);
    setForm({ ...form, [name]: value })
  };



  useEffect(() => {
    register({ name: 'nome' }, { required: 'Nome do documento é obrigatório' });
    register({ name: 'idTipo' }, { required: 'Tipo do documento é obrigatório' });
  }, [])


  const handleUpload = (file) => {
    setFile(file);
  }

  const submit = async () => {

    if (file) {

      let formData = new FormData();
      const { nome, idTipo } = form;
      formData.append("file", file)
      formData.append("nome", nome);
      formData.append("tipo", idTipo);
      onClose();

      try {
        const response = await cadastrar(formData);

        if (response && response.status === 200) {
          enqueueSnackbar("Documento cadastrado com sucesso :)", { variant: 'success' });
          afterSubmit();
        }else {
          enqueueSnackbar("Ocorreu um erro ao cadastrar o documento", { variant: 'error' })
        }
      } catch (e) {
        enqueueSnackbar("Ocorreu um erro ao cadastrar o documento", { variant: 'error' })
      }

    } else {
      enqueueSnackbar("Selecione um arquivo para upload", { variant: 'info' })
    }

  }
  const { nome, idTipo } = form;

  return (
    <div>
      <Dialog fullWidth open={open} onClose={onClose}>
        <form onSubmit={handleSubmit(submit)}>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <UploadFile titulo="Documentos" onUpload={handleUpload} />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  name="nome"
                  InputLabelProps={{ shrink: true }}
                  value={nome}
                  onChange={handleChange}
                  variant="outlined"
                  margin="normal"
                  error={!!errors.nome}
                  helperText={errors.nome && errors.nome.message}
                  label="Nome do Documento" />
              </Grid>

              <Grid item xs={6}>
                <FormControl fullWidth error={!!errors.idTipo}>
                  <FormLabel shrink="true">Tipo de Documento</FormLabel>
                  <Select
                    id="idTipo"
                    name="idTipo"
                    value={idTipo}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    inputProps={{
                      margin: 'normal'
                    }}>
                    >
                  {tipos.map((tipo) => (
                      tipo.selecionavel && <MenuItem key={tipo.id} value={tipo.id}>{tipo.descricao}</MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{errors.idTipo && errors.idTipo.message}</FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="outlined"
              onClick={onClose}>
              Cancelar
            </Button>
            <Button
              type="submit"
              variant="contained">
              Salvar
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  )

}

export default CadastrarDocumento;
